import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {MatButtonModule,
  MatProgressBarModule,
  MatSnackBarModule,
 MatCardModule,
 MatCheckboxModule,
 MatSelectModule,
 MatFormFieldModule,
 MatInputModule,
 MatGridListModule,
 MatAutocompleteModule,
 MatTabsModule,
 MatIconModule,
 MatRadioModule,
 MatDatepickerModule,
 MatNativeDateModule,
 MatTableModule,
 MatBottomSheetModule,
 MatListModule,
 MatDialogModule,
 MatRippleModule,
 MatTooltipModule,MatExpansionModule,MatStepperModule} from '@angular/material';
 
const modules = [
  MatButtonModule,
  MatFormFieldModule,
  MatTabsModule,
  MatCardModule,
  MatInputModule,
  MatRippleModule,MatSelectModule,
  MatCheckboxModule,
  MatGridListModule,
  MatIconModule,
  MatRippleModule,
  MatRadioModule,
  MatDatepickerModule,
  MatSnackBarModule,
  MatAutocompleteModule,
  MatNativeDateModule,
  MatProgressBarModule,
  MatBottomSheetModule,
  MatDialogModule,
  MatListModule,
  MatTableModule,
  MatExpansionModule,
  MatTooltipModule,
  MatStepperModule,
  
];

import { InputFileTemplateComponent } from '../components/input-file-template/input-file-template.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTemplateComponent } from '../components/input-template/input-template.component';
import { SearchableSelectComponent } from '../components/searchable-select/searchable-select.component';
import { SharedModule } from '../shared/shared.module';
import { BottomSheetOverviewExampleSheet, CenterSheetOverviewExampleSheet } from '../tabs/tabs.component';
import { ComposeMessageComponent } from '../components/compose-message/compose-message.component';
import { MessagesComponent } from '../components/messages/messages.component';
import { SentMessagesComponent } from '../components/sent/sent.component';
import { ViewMessageComponent } from '../components/view-message/view-message.component'; 
import { TrashComponent } from '../components/trash/trash.component';
import { InputKeyFacilityComponent } from '../components/input-key-facility/input-key-facility.component';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
 
import { AngularEditorModule } from '@kolkov/angular-editor';
import { PaymentPopupComponent } from '../components/payment-popup/payment-popup.component'; 
import { AmPagination } from '../components/am-pager/am-pager.component';
import { ConfirmPopupComponent } from '../sub-admin/confirm-popup/confirm-popup.component';
import { TicketsComponent } from '../components/Ticket/Tickets.component';
import { ApplicationTypePopupComponent } from '../trainer/application-type-popup/application-type-popup.component';
import { NextTabButtonComponent } from '../components/next-tab-button/next-tab-button.component';
@NgModule({
  declarations: [
    InputFileTemplateComponent,
    InputTemplateComponent,
    SearchableSelectComponent,
    BottomSheetOverviewExampleSheet,
    CenterSheetOverviewExampleSheet,
    ComposeMessageComponent,
    MessagesComponent,
    SentMessagesComponent,
    ViewMessageComponent,
    InputKeyFacilityComponent,
    TrashComponent,
    PaymentPopupComponent,
    NextTabButtonComponent,
    AmPagination,
    ConfirmPopupComponent,
    TicketsComponent,
    ApplicationTypePopupComponent
    
],

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    AngularEditorModule,
    NgxMaterialTimepickerModule,
    
    ...modules
  ],
  providers: [MatDatepickerModule],
 
  entryComponents:[
    AmPagination,
    BottomSheetOverviewExampleSheet,
    PaymentPopupComponent,
    ConfirmPopupComponent,
    ApplicationTypePopupComponent,
    CenterSheetOverviewExampleSheet,
    NextTabButtonComponent,
     
  
  ],
 
  exports:[ ...modules,InputFileTemplateComponent,
    InputTemplateComponent,
    InputKeyFacilityComponent,
    SearchableSelectComponent,
    ComposeMessageComponent,
    MessagesComponent,
    SentMessagesComponent,
    ViewMessageComponent,
    TrashComponent,
    PaymentPopupComponent,
    NextTabButtonComponent,
    AmPagination,
    ConfirmPopupComponent,
    TicketsComponent

    // NgxMaterialTimepickerModule

  ]
})
export class MaterialSharedModule { }
